import { ColumnFiltersState, SortingState } from "@tanstack/react-table";

export interface TableState {
  sorting: SortingState;
  columnFilters: ColumnFiltersState;
  globalFilter: string;
  globalFilterValue: string;
}

const defaultTableState: TableState = {
  sorting: [],
  columnFilters: [],
  globalFilter: "",
  globalFilterValue: "",
};

const STORAGE_PREFIX = "table_state_";

export const getTableStateFromStorage = (tableKey: string): TableState => {
  try {
    const stored = sessionStorage.getItem(`${STORAGE_PREFIX}${tableKey}`);
    if (stored) {
      return JSON.parse(stored) as TableState;
    }
  } catch {
    // If any error occurs (e.g., JSON parsing), return default state
    return defaultTableState;
  }

  return defaultTableState;
};

export const saveTableStateToStorage = (
  tableKey: string,
  state: TableState,
): void => {
  try {
    sessionStorage.setItem(
      `${STORAGE_PREFIX}${tableKey}`,
      JSON.stringify(state),
    );
  } catch {
    // Handle storage errors silently
  }
};
